'use client';

import dynamic from 'next/dynamic';
import { useQuality } from '@/components/shared/QualityProvider';

/**
 * Tiny client-side gate that decides whether to load the heavy 3D blob
 * overlay. The implementation in `TrailingBlobCanvas.tsx` pulls in
 * three.js, @react-three/fiber, @react-three/postprocessing and gsap —
 * about a megabyte of unused JS on mobile, where the blob never renders.
 *
 * Wrapping the import in `next/dynamic({ ssr: false })` AND gating the
 * render on tier means:
 *   • Mobile / low tier:  module never downloads (React doesn't ask for it)
 *   • Mid / high tier:    chunk loads only after the QualityProvider
 *                         resolves, well after first paint
 *
 * Keep this file imports-light — anything statically imported here lands
 * back on the mobile bundle.
 */
const TrailingBlobCanvas = dynamic(
  () => import('./TrailingBlobCanvas').then((m) => ({ default: m.TrailingBlobCanvas })),
  { ssr: false },
);

export function TrailingBlob() {
  const { tier } = useQuality();
  if (tier !== 'high' && tier !== 'mid') return null;
  return <TrailingBlobCanvas />;
}
